export function portalAssetUrl(filename) {
  const base = String(process.env.PUBLIC_URL || "").replace(/\/+$/, "");
  const cleanName = String(filename || "").replace(/^\/+/, "");
  return `${base}/${cleanName}`;
}
